export const skills = [
    {
        icon: "https://cdn-icons-png.flaticon.com/512/174/174854.png",
        title: "HTML",
        tag: "frontend"
    },
    {
        icon: "https://cdn-icons-png.flaticon.com/512/732/732190.png",
        title: "CSS",
        tag: "frontend"
    },
    {
        icon: "https://cdn-icons-png.flaticon.com/512/5968/5968292.png",
        title: "JavaScript",
        tag: "frontend"
    },
    {
        icon: "https://cdn-icons-png.flaticon.com/512/5968/5968292.png",
        title: "JavaScript",
        tag: "backend"
    },
    {
        icon: "https://cdn-icons-png.flaticon.com/512/760/760457.png",
        title: "react",
        tag: "frontend"
    },
    {
        icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAXUZWEpOwHfwLAhuY_jSO5ojgCvyRVa_nug&s",
        title: "Express JS",
        tag: "backend"
    },
    
    {
        icon: "https://img.icons8.com/fluency/512/node-js.png",
        title: "Node.js",
        tag: "backend"
    },
    
    {
        icon: "https://img.icons8.com/color/512/mongodb.png",
        title: "MongoDB",
        tag: "backend"
    },
    {
        icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRkDSk3EMoHDZdD-THO_tHbvGhp7jtFzkEhEg&s",
        title: "SQL",
        tag: "backend"
    },
    {
        icon: "https://img.icons8.com/color/512/bootstrap.png",
        title: "Bootstrap",
        tag: "frontend"
    },
    {
        icon: "https://img.icons8.com/ios-glyphs/512/github.png",
        title: "Github",
        tag: "platform"
    },
    {
        icon: "https://i.ibb.co/61nck0S/download-removebg-preview.png",
        title: "VS Code",
        tag: "platform"
    },
    {
        icon: "https://img.icons8.com/color/512/git.png",
        title: "Git",
        tag: "platform"
    },
    {
        icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFc8kZjnxjVgVZRNWMzB0_YYlm8730LL5SJQ&s",
        title: "BackStage",
        tag: "platform"
    },
    {
        icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUD88v317AFqmO4mmDnrQS5V5HgpKohlPNRg&s",
        title: "sonarcloud",
        tag: "platform"
    }

]

export const projects = [
    {
        id: 1,
        title: 'AI LIVE INTERVIEW',
        type: 'AI',
        image: 'https://i.postimg.cc/0QXKh0bm/Screenshot-from-2024-12-04-20-59-37-Screenshot-from-2024-12-04-21-02-52.jpg',
        description: 'This application is designed such that the interview session is conducted by the AI.The applicant can practice on how to do interview with the help of AI before their actual Interview.The User will give four inputs: name,resume link, for which post the applicant is applying for,name of the company that conducts the interview. Based on the Input given the questions are asked.',
        techStack: ['React', 'Node Js','Mongodb','three.js','tailwindcss'],
        github: 'https://drive.google.com/file/d/1YWCUdev5kfG6bJ0qX_o3aSlYVn1Qtsmz/view?usp=sharing',
        liveDemo: 'https://drive.google.com/file/d/1YWCUdev5kfG6bJ0qX_o3aSlYVn1Qtsmz/view?usp=sharing',
    },
    {
        id: 2,
        title: 'Event_Management',
        type: 'FULL STACK',
        image: 'https://i.postimg.cc/N0CQXHpB/Whats-App-Image-2024-06-13-at-10-49-57-PM.jpg',
        description: 'The project featured a multi-role login system with four types of users: student, admin, club member, and club head. Club members could create events, which then required approval from the club head. Once approved, the event details were sent to the admin for verification. After verification, the event booking process was completed.Students could register for events and make payments using Razorpay integration.',
        techStack: ['React', 'Node Js', 'Mongodb'],
        github: 'https://github.com/jeyachandranj/Event_Management_React.git',
        liveDemo: 'https://master-event-mangagement.netlify.app/'
    },
    {
        id: 3,
        title: 'LeetCode_Management',
        type: 'FULL STACK',
        image: 'https://i.postimg.cc/B63yWq92/Screenshot-from-2024-11-10-13-47-16-Screenshot-from-2024-11-14-20-56-26.jpg',
        description: 'This leaderboard project highlights top performers across Easy, Medium, Hard, and Total categories. Using MongoDB aggregation, it fetches unique top scorers efficiently. The React.js frontend offers a dynamic UI, showcasing students ranks with custom icons and responsive design, promoting competition and celebrating achievements across various skill levels.',
        techStack: ['React', 'Node Js','mongodb','flask'],
        github: 'https://drive.google.com/file/d/1_qQVi98-gw__slrAvff8RLh10ISBpJWd/view?usp=sharing',
        liveDemo: 'https://drive.google.com/file/d/1_qQVi98-gw__slrAvff8RLh10ISBpJWd/view?usp=sharing',
    },
    {
        id: 4,
        title: 'AYUSH Startup Registration Portal - (SIH)',
        type: 'FULL STACK',
        image: 'https://i.postimg.cc/c4DNQ8q2/sih.jpg',
        description: "A streamlined platform for AYUSH startups, offering simplified registration, AI-powered document verification, and real-time status updates. It fosters collaboration through mentorship, funding opportunities, and role-based access. With enhanced transparency and efficiency, the portal supports innovation, growth, and accessibility for startups and stakeholders in the AYUSH sector.",
        techStack: ['React', 'Node Js','Mongodb'],
        github: 'https://github.com/jeyachandranj/AYUSH.git',
        liveDemo: 'https://youtu.be/5NyNDuc4Ouk',
    },
    {
        id: 5,
        title: 'Ecomerce Book Store',
        type: 'FULL STACK',
        image: 'https://i.ibb.co/62Tm1NN/Screenshot-From-2025-02-28-23-56-02.png',
        description: 'The system has two user roles: Admin (who manages books and orders) and Customer (who browses and orders books). The platform includes secure authentication, an order dashboard, and a seamless shopping experience. The system ensures smooth transactions, real-time updates, and an intuitive user interface for both admin and customers. ',
        techStack: ['React', 'Node Js','Mongodb','flask','sql'],
        github: 'https://github.com/jeyachandranj/Ecomerce.git',   
        liveDemo: 'https://sp-bookstore.netlify.app/',
    },
    {
        id: 6,
        title: 'SQL Learning Platform',
        type: 'FULL STACK',
        image: 'https://i.postimg.cc/853r0WRb/image.jpg',
        description: 'An interactive educational tool designed to help students master SQL through assignments, contests, and labs. With role-based access for colleges, faculty, and students, it offers AI-powered assistance, including NLP-to-SQL conversion, query optimization, and interview preparation. Features include interactive SQL labs, peer discussion forums, and capstone projects, fostering hands-on learning and real-world application. ',
        techStack: ['React', 'Node Js','Mongodb','flask','sql'],
        github: 'https://github.com/satheesh1022005/DBlearn.git',   
        liveDemo: 'https://dblearnorg.netlify.app/',
    },
    {
        id: 7,
        title: 'Stream_Analytics',
        type: 'FULL STACK',
        image: 'https://i.postimg.cc/yYV9syFp/Whats-App-Image-2024-06-17-at-12-27-29-PM.jpg',
        description: 'React food delivery dashboard, 1GB of data is generated randomly, streamed through Kafka with Zookeeper for coordination, and stored in an SQL database. The data is processed in chunks, ensuring each chunk is parsed and displayed within 2-3 seconds, allowing the UI to update smoothly with real-time charts, showing food delivery metrics and trends. ',
        techStack: ['React', 'spring boot', 'sql'],
        github: 'https://github.com/jeyachandranj/STREAM_ANALYTICS_UI_REACT.git',
        liveDemo: 'https://github.com/jeyachandranj/STREAM_ANALYTICS_UI_REACT.git/'
    },
    {
        id: 8,
        title: 'Google-Form-AI',
        type: 'AI',
        image: 'https://i.postimg.cc/d3t19jS1/image-1.jpg',
        description: "I'm developing a project that integrates AI with Google Forms. Users can input a PDF, DOC file, or a YouTube link, which is processed using LangChain to dynamically generate a set number of questions. These questions are then automatically added to a Google Form. During the test, video and audio monitoring will be enabled, and the final scores will be stored in a database.",
        techStack: ['REACT','Flask','Mongodb'],
        github: 'https://github.com/jeyachandranj/Google-Form-AI.git',
        liveDemo: 'https://drive.google.com/file/d/1ISBeh7CAGSGOkmob5XUTeMUyTCyHi0Yb/view?usp=drive_link',
    },
]